<div class="container-fluid container-margin-top">
  <div class="row">
    <!-- Candidates List -->
    <div class="col-12 col-md-2 mb-3">
      <app-list-candidates [showOnlyHiredCandidate]="true"></app-list-candidates>
    </div>

    <!-- Review Section -->
    <div class="col-12 col-md-9  pt-5">
      <app-review *ngIf="!isReviewGiven" (reviewEvent)="onReviewSave($event)"></app-review>
      <ng-container *ngFor="let jobReview of jobReviews">
        <app-display-review [review]="jobReview"></app-display-review>
      </ng-container>
    </div>
  </div>
</div>
